// პარამეტრები — settings and its cards, the palettes and density, „მარტივი რეჟიმი
// (lib/features), support access (lib/support), the subscription panel, tools.
// The backup FILE's own texts (lib/backup) stay Georgian: a document.
export const settings = {
  'feat.group.pos': 'სალარო',
  'feat.group.warehouse': 'საწყობი',
  'feat.group.accounting': 'ბუღალტერია',
  'feat.credit': 'ნისია',
  'feat.credit.shows': 'გადახდის ღილაკი „ნისია" (F8) და მოდული „ნისია"',
  'feat.hold': 'კალათის გადადება',
  'feat.hold.shows': 'ღილაკი „გადადება" (F10)',
  'feat.discount': 'ფასდაკლება სალაროში',
  'feat.discount.shows': 'ხელით ფასდაკლების ველი კალათაში',
  'feat.models': 'ზომები და ფერები',
  'feat.models.shows': 'ღილაკი „მოდელი" — ტანსაცმელი, ფეხსაცმელი',
  'feat.conversions': 'დაშლა',
  'feat.conversions.shows': 'ღილაკი „დაშლა" — შეკვრა ცალებად, დაფქვა',
  'feat.promotions': 'აქციები და კომბო',
  'feat.promotions.shows': 'ღილაკი „აქციები"',
  'feat.rsge': 'RS.GE-ის ჩანართები',
  'feat.rsge.shows': '„გამავალი ზედნადები" და „RS.GE შედარება"',
  'feat.why.customers': '{n} კლიენტი გყავს',
  'feat.why.creditSales': 'ნისიით გაყიდვა გაქვს',
  'feat.why.noCredit': 'კლიენტი არ გყავს და ნისიით არ გაგიყიდია',
  'feat.why.holdDefault': 'ჩვეულებრივ ჩანს — გამორთე, თუ არ იყენებ',
  'feat.why.discountUsed': 'მაღაზია ფასდაკლებას იყენებს',
  'feat.why.noDiscount': 'ფასდაკლება არ გაგიკეთებია',
  'feat.why.hasModels': 'ზომებიანი მოდელი გაქვს',
  'feat.why.clothing': 'ტანსაცმლის მაღაზიაა',
  'feat.why.noModels': 'ზომებიანი მოდელი არ გაქვს',
  'feat.why.convUsed': 'დაშლა გამოგიყენებია',
  'feat.why.coffee': 'ყავის მაღაზიაა',
  'feat.why.convTemplate': 'ამ შაბლონის რჩევა „დაშლას" იყენებს',
  'feat.why.grocery': 'სასურსათო მაღაზიაა',
  'feat.why.noConv': 'დაშლა არ გამოგიყენებია',
  'feat.why.hasPromo': 'აქცია გაქვს',
  'feat.why.noPromo': 'აქცია არ გაქვს',
  'feat.why.rsgeDefault': 'ჩვეულებრივ ჩანს — გამორთე, თუ RS.GE-ს ზედნადებს არ წერ',
  'theme.light': 'ქაღალდი',
  'theme.light.hint': 'თბილი, მქრქალი ღია — e-reader-ის ფურცელი',
  'theme.slate': 'სლეიტი',
  'theme.slate.hint': 'გრილი ღია ნაცრისფერი, თეთრი ბარათები — Square / Shopify',
  'theme.mist': 'ნისლი',
  'theme.mist.hint': 'რბილი ნაცრისფერ-ცისფერი, მუქი ლურჯი ტექსტი — არაფერი თეთრი, თვალს არ ღლის',
  'theme.sage': 'სალბი',
  'theme.sage.hint': 'ღია მწვანე-ნაცრისფერი, მწვანე აქცენტი — Loyverse',
  'theme.sand': 'ქვიშა',
  'theme.sand.hint': 'თბილი ბეჟი, სპილენძის აქცენტი — კაფე-ბარის სითბო',
  'theme.cherry': 'ალუბალი',
  'theme.cherry.hint': 'რბილი ვარდისფერი, ღვინისფერი აქცენტი — თბილი და მშვიდი',
  'theme.graphite': 'გრაფიტი',
  'theme.graphite.hint': 'რბილი მუქი, არა შავი — Toast-ის ბნელი რეჟიმი',
  'theme.dark': 'ღამე',
  'theme.dark.hint': 'მუქი ნახშირი-ლურჯი — ბნელი დახლისთვის',
  'theme.ocean': 'ოკეანე',
  'theme.ocean.hint': 'ღრმა ზღვისფერი, ლურჯ-მწვანე აქცენტი — მუქი, მაგრამ ცოცხალი',
  'theme.amethyst': 'ამეთვისტო',
  'theme.amethyst.hint': 'ღრმა ინდიგო-იისფერი, ყინულისფერი ცისფერი აქცენტით — მუქი, მაგრამ მკაფიო',
  'theme.darkcherry': 'მუქი ალუბალი',
  'theme.darkcherry.hint': 'ალუბლის ღვინისფერი ფონი, ჟოლოსფერი ღილაკები — ღრმა და თბილი',
  'density.auto': 'ავტომატური',
  'density.auto.hint': 'ლეპტოპზე კომპაქტური, დიდ მონიტორზე ჩვეულებრივი',
  'density.compact': 'კომპაქტური',
  'density.compact.hint': 'მეტი ეტევა — პატარა ან 15.6" ეკრანისთვის',
  'density.comfortable': 'ჩვეულებრივი',
  'density.comfortable.hint': 'როგორც დიდ მონიტორზე',
  'support.dur.60': '1 საათი',
  'support.dur.240': '4 საათი',
  'support.dur.1440': '24 საათი',
  'support.left.m': '{m} წთ',
  'support.left.hm': '{h} სთ {m} წთ',
  'support.left.h': '{h} სთ',
  'support.err.INVALID_CODE': 'კოდი არასწორია ან მისი ვადა გავიდა',
  'support.err.TOO_MANY_ATTEMPTS': 'ძალიან ბევრი არასწორი კოდი — სცადე 10 წუთში',
  'support.err.OWN_SHOP': 'ეს შენი მაღაზიაა — აქ კოდი არ გჭირდება',
  'support.err.GRANT_NOT_OPEN': 'მოთხოვნა უკვე აღარ მოქმედებს',
  'support.err.NOT_SENT': 'მოთხოვნა ჯერ არ გაგზავნილა',
  'support.err.SUPPORT_CANNOT': 'მხარდაჭერის რეჟიმში ეს მხოლოდ მფლობელს შეუძლია',
  'support.err.default': 'ვერ მოხერხდა — სცადე თავიდან',
  // 1.45 — a shop's help request reaches the platform admin (components/support-alerts.tsx)
  'sup.alert.one': '{shop} ({no}) ითხოვს დახმარებას',
  'sup.alert.many': '{n} მაღაზია ითხოვს დახმარებას',
  'sup.alert.view': 'ნახვა',
  'sup.alert.badge': '{n} დახმარების მოთხოვნა',
  'sup.alert.pill': '{n} დახმარება',
  'support.tbl.products': 'პროდუქტი',
  'support.tbl.categories': 'კატეგორია',
  'support.tbl.product_addons': 'დანამატი',
  'support.tbl.product_ingredients': 'ფასში შედის',
  'support.tbl.product_conversions': 'დაშლა',
  'support.tbl.product_breakdowns': 'დაშლა ნაწილებად',
  'support.tbl.product_breakdown_parts': 'დაშლის ნაწილი',
  'support.tbl.suppliers': 'მომწოდებელი',
  'support.tbl.supplier_product_codes': 'მომწოდებლის კოდი',
  'support.tbl.purchases': 'შესყიდვა',
  'support.tbl.purchase_items': 'შესყიდვის ხაზი',
  'support.tbl.promotions': 'აქცია',
  'support.tbl.promotion_items': 'აქციის პროდუქტი',
  'support.tbl.customers': 'კლიენტი',
  'support.tbl.settings': 'პარამეტრი',
  'support.tbl.branches': 'ფილიალი',
  'support.tbl.cashiers': 'მოლარე',
  'support.tbl.stocktakes': 'ინვენტარიზაცია',
  'support.tbl.stock_transfers': 'გადაზიდვა',
  'support.op.INSERT': 'დაემატა',
  'support.op.UPDATE': 'შეიცვალა',
  'support.op.DELETE': 'წაიშალა',
  'support.fld.name': 'სახელი',
  'support.fld.sale_price': 'ფასი',
  'support.fld.purchase_price': 'თვითღირებულება',
  'support.fld.wholesale_price': 'საბითუმო ფასი',
  'support.fld.quantity': 'რაოდენობა',
  'support.fld.barcode': 'შტრიხკოდი',
  'support.fld.category_id': 'კატეგორია',
  'support.fld.unit': 'ერთეული',
  'support.fld.photo_url': 'ფოტო',
  'support.fld.plu_code': 'PLU',
  'support.fld.expiry_date': 'ვადა',
  'support.fld.value': 'მნიშვნელობა',
  'support.fld.phone': 'ტელეფონი',
  'support.fld.note': 'შენიშვნა',
  'support.fld.active': 'აქტიური',
  'support.fld.tin': 'ს/კ',
  'support.fld.legal_name': 'იურიდიული სახელი',
  'support.fld.legal_address': 'მისამართი',
  'support.fld.parent_id': 'მშობელი კატეგორია',
  'support.fld.price': 'ფასი',
  'support.fld.promo_price': 'აქციის ფასი',
  'support.fld.pin': 'PIN',
  'support.fld.branch_id': 'ფილიალი',
  'support.fld.is_default': 'მთავარი',
  'support.set.companyName': 'კომპანიის სახელი',
  'support.set.companyId': 'საიდენტიფიკაციო კოდი',
  'support.set.address': 'მისამართი',
  'support.set.phone': 'ტელეფონი',
  'support.set.bankDetails': 'საბანკო რეკვიზიტები',
  'support.set.taxStatus': 'საგადასახადო სტატუსი',
  'support.set.loyaltyEnabled': 'ბონუსი ჩართულია',
  'support.set.loyaltyPct': 'ბონუსის %',
  'support.set.scaleEnabled': 'ელექტრო სასწორი',
  'support.set.shareCatalog': 'საერთო კატალოგი',
  'support.set.cashierStocktake': 'მოლარის ინვენტარიზაცია',
  'support.set.cameraUrlTemplate': 'კამერის ბმული',
  'support.set.fiscalKasaEnabled': 'ფისკალიზაცია',
  'support.set.fiscalDevice': 'ფისკალური აპარატი',
  'support.set.receiptFooter': 'ჩეკის ბოლო ტექსტი',
  'support.chg.title': '{what}{name} {op}',
  'support.chg.name': ' „{name}"',
  'set.sec.company': 'კომპანიის ინფორმაცია',
  'set.sec.billing': 'გამოწერა',
  'set.sec.support': 'დახმარება',
  'set.sec.pin': 'PIN კოდი',
  'set.sec.branches': 'ფილიალები',
  'set.sec.kiosk': 'კიოსკის რეჟიმი',
  'set.sec.ai': 'AI ფუნქციები',
  'set.sec.loyalty': 'ლოიალობა — ბონუსი და ფასის ჯგუფები',
  'set.sec.appearance': 'გარეგნობა',
  'set.sec.rsge': 'RS.GE',
  'set.sec.fiscal': 'ფისკალიზაცია (kasa.ge)',
  'set.sec.qrpay': 'QR-გადახდა (Keepz)',
  'set.sec.scale': 'ელექტრო სასწორი',
  'set.sec.camera': 'ვიდეო-კამერები',
  'set.sec.catalog': 'საერთო კატალოგი',
  'set.sec.backup': 'მონაცემების ასლი',
  'set.sec.delete': 'ანგარიშის წაშლა',
  'set.sec.report': 'დილის ანგარიში',
  'set.sec.telegram': 'Telegram',
  'set.sec.float': 'კასაში დასატოვებელი თანხა',
  'set.sec.simple': 'მარტივი რეჟიმი',
  'set.title': 'პარამეტრები',
  'set.group.shop': 'მაღაზია',
  'set.group.register': 'სალარო',
  'set.group.connections': 'კავშირები',
  'set.group.account': 'ანგარიში',
  'set.groups.aria': 'პარამეტრების ჯგუფები',
  'set.tax.none': 'არ არის მითითებული',
  'set.tax.small': 'მცირე ბიზნესი (1%)',
  'set.tax.vat': 'დღგ-ს გადამხდელი (18%)',
  'set.tbl.branches': 'ფილიალები',
  'set.tbl.categories': 'კატეგორიები',
  'set.tbl.suppliers': 'მომწოდებლები',
  'set.tbl.customers': 'მოვალეები',
  'set.tbl.cashiers': 'მოლარეები',
  'set.tbl.products': 'პროდუქცია',
  'set.tbl.product_stock': 'მარაგი ფილიალებში',
  'set.tbl.shifts': 'ცვლები',
  'set.tbl.sales': 'გაყიდვები',
  'set.tbl.sale_items': 'გაყიდვის ხაზები',
  'set.tbl.purchases': 'შესყიდვები',
  'set.tbl.purchase_items': 'შესყიდვის ხაზები',
  'set.tbl.customer_payments': 'ნისიის გადახდები',
  'set.tbl.supplier_payments': 'მომწოდებლის გადახდები',
  'set.tbl.expenses': 'ხარჯები',
  'set.tbl.stocktakes': 'ინვენტარიზაციები',
  'set.tbl.stocktake_items': 'ინვენტარიზაციის ხაზები',
  'set.tbl.stock_transfers': 'გადატანები',
  'set.tbl.stock_transfer_items': 'გადატანის ხაზები',
  'set.tbl.product_addons': 'თანმხლები',
  'set.tbl.product_ingredients': 'ფასში შედის',
  'set.tbl.product_conversions': 'დაშლები',
  'set.tbl.product_breakdowns': 'დაშლები ნაწილებად',
  'set.tbl.product_breakdown_parts': 'დაშლის ნაწილები',
  'set.tbl.supplier_product_codes': 'მომწოდებლის კოდები',
  'set.tbl.held_carts': 'შეჩერებული კალათები',
  'set.tbl.fiscal_reports': 'ფისკალური ჩეკები',
  'set.tbl.settings': 'პარამეტრები',
  'set.tbl.bonus_ledger': 'ბონუსების ისტორია',
  'set.tbl.recurring_expenses': 'ყოველთვიური ხარჯები',
  'set.tbl.cart_removals': 'კალათიდან გაუყიდავად ამოღებული',
  'set.tbl.price_changes': 'ფასის ცვლილებები',
  'set.tbl.store_sites': 'საიტის პარამეტრები',
  'set.tbl.cash_movements': 'სალაროდან გატანა და შეტანა',
  'set.tbl.supplier_returns': 'მომწოდებელთან დაბრუნებები',
  'set.tbl.supplier_return_items': 'დაბრუნებების ხაზები',
  'set.tbl.repairs': 'შეკეთებები',
  'set.tbl.invoices': 'ანგარიშ-ფაქტურები',
  'set.tbl.outgoing_waybills': 'გაგზავნილი ზედნადებები',
  'set.tbl.qr_payments': 'QR გადახდები',
  'set.tbl.online_orders': 'ონლაინ შეკვეთები',
  'set.tbl.online_order_items': 'ონლაინ შეკვეთის ხაზები',
  'set.tbl.online_order_events': 'ონლაინ შეკვეთის ისტორია',
  'set.tbl.prepaids': 'სასაჩუქრე ბარათები და წინასწარი გადახდები',
  'set.tbl.prepaid_moves': 'წინასწარი თანხების მოძრაობა',
  'set.tbl.demand_records': 'მყიდველების მოთხოვნები',
  'set.tbl.supplier_orders': 'მომწოდებლის შეკვეთები',
  'set.tbl.supplier_order_items': 'მომწოდებლის შეკვეთების სტრიქონები',
  'set.tbl.dining_halls': 'დარბაზები',
  'set.tbl.dining_tables': 'მაგიდები',
  'set.tbl.table_orders': 'მაგიდების ანგარიშები',
  'set.tbl.table_order_lines': 'მაგიდების ანგარიშების პოზიციები',
  'set.tbl.table_order_batches': 'სამზარეულოს ფურცლები',
  'set.tbl.table_visits': 'სტუმრები მაგიდებთან',
  'set.tbl.table_requests': 'სტუმრის მოთხოვნები (QR)',
  'set.tbl.table_request_lines': 'სტუმრის შეკვეთის პოზიციები',
  'support.end.owner': 'შენ დაასრულე',
  'support.end.support': 'მხარდაჭერამ დაასრულა',
  'support.end.replaced': 'ახალმა კოდმა ჩაანაცვლა',
  'support.end.expired': 'ვადა ამოიწურა',
  'support.grant.unused': 'არ გამოყენებულა',
  'support.grant.waiting': 'ელოდება მხარდაჭერას',
  'support.grant.active': 'მიმდინარეობს',
  'support.grant.ended': 'დასრულდა',
  'bill.short.trial': 'საცდელი · {n} დღე',
  'bill.short.grace': 'საცდელი დასრულდა',
  'bill.short.locked': 'დაკეტილია',
  'bill.short.until': '{date}-მდე',
  'bill.short.overdue': 'ვადაგადაცილებული',
  'bill.short.none': 'აქტიური',
  'bill.st.trial': 'საცდელი პერიოდი — დარჩა {n} დღე',
  'bill.st.grace': 'საცდელი დასრულდა — {n} დღეში ჩაიკეტება',
  'bill.st.locked': 'საცდელი დასრულდა — მაღაზია დაკეტილია',
  'bill.st.paid': 'გადახდილია {date}-მდე',
  'bill.st.dueSoon': 'გადახდილია {date}-მდე — დარჩა {n} დღე',
  'bill.st.overdue': 'ვადა გადაცილებულია {n} დღით',
  'bill.st.none': 'გამოწერა აქტიურია',
  'set.page.1': 'PIN კოდი უნდა შეიცავდეს 4-6 ციფრს',
  'set.page.2': 'PIN კოდები არ ემთხვევა',
  'set.page.3': 'ეს საკეტის PIN-ია — ფასდაკლებისთვის სხვა აირჩიე',
  'set.page.4': 'მიმდინარე PIN კოდი არასწორია',
  'set.page.5': '{DEFAULT_LOCK_PIN} ყველამ იცის — სხვა აირჩიე',
  'set.page.6': 'კომპანიის ინფორმაცია',
  'set.page.7': 'გამოჩნდება ქვითრებზე და ანგარიშებში',
  'set.page.8': 'კომპანიის სახელი',
  'set.page.9': 'მაგ. შპს ჩემი მაღაზია',
  'set.page.10': 'საიდენტიფიკაციო კოდი',
  'set.page.11': 'მაგ. 205123456',
  'set.page.12': '9-ნიშნა საიდენტიფიკაციო კოდი',
  'set.page.13': 'ტელეფონი',
  'set.page.14': 'მისამართი',
  'set.page.15': 'ქ. თბილისი, ...',
  'set.page.16': 'საბანკო რეკვიზიტები (IBAN)',
  'set.page.17': 'გამოჩნდება ნისიის შეხსენების ტექსტში — ცარიელი = გამოტოვდება',
  'set.page.18': 'საგადასახადო სტატუსი',
  'set.page.19': 'ანგარიშებში გამოჩნდება შესაბამისი გადასახადის ბარათი (საორიენტაციო)',
  'set.page.20': ' შენახულია',
  'set.page.21': 'PIN კოდები',
  'set.page.22': 'ეკრანის ჩაკეტვა და ფასდაკლების დადასტურება',
  'set.page.23': 'PIN ჯერ არ აგირჩევია.',
  'set.page.24': ' ჩაკეტილი ეკრანი და კიოსკი ახლა ნაგულისხმევი',
  'set.page.25': '-ით იხსნება, რომელსაც ნებისმიერი გამოიცნობს. დააყენე შენი.',
  'set.page.26': 'საკეტის მიმდინარე PIN:',
  'set.page.27': 'მიმდინარე PIN',
  'set.page.28': 'ახალი PIN (4-6 ციფრი)',
  'set.page.29': 'გაიმეორე ახალი PIN',
  'set.page.30': ' PIN კოდი შეიცვალა',
  'set.page.31': 'საკეტის PIN-ის შეცვლა',
  'set.page.32': 'ფასდაკლების PIN',
  'set.page.33': 'ამ კოდით ადასტურებ ფასდაკლებას, რომელიც მოლარის ლიმიტს აჭარბებს. შენს გარდა მას ვერავინ ხედავს — ვერც მოლარე, ვერც ბუღალტერი, ვერც MartePOS-ის მხარდაჭერა.',
  'set.page.34': 'ახლა ის საკეტის PIN-ის ტოლია.',
  'set.page.35': ' საკეტის PIN მოლარესაც უწერია მოწყობილობაზე — ე.ი. ფასდაკლების ლიმიტიც მისთვის ღიაა. დააყენე სხვა კოდი.',
  'set.page.36': 'ახალი ფასდაკლების PIN',
  'set.page.37': 'გაიმეორე',
  'set.page.38': ' ფასდაკლების PIN შეიცვალა',
  'set.page.39': 'ფასდაკლების PIN-ის დაყენება',
  'set.page.40': 'მხარდაჭერის რეჟიმში ',
  'set.page.41': ' მხოლოდ მფლობელისაა — პაროლები, გასაღებები, PIN, გადახდა და მონაცემების აღდგენა მხარდაჭერისთვის დაკეტილია.',
  'set.page.42': 'გამოწერა',
  'set.page.43': 'MartePOS-ის სააბონენტო — ვადა',
  'set.page.44': 'MartePOS-ის სააბონენტო — ვადა, თანხა და სად გადაიხადო',
  'set.page.45': 'გარეგნობა',
  'set.page.46': 'ფერების პალიტრა ამ მოწყობილობისთვის — ყოველ დახლს თავისი შეიძლება ჰქონდეს. სათაურის მზე/მთვარე ღიასა და მუქს შორის გადართავს.',
  'set.page.47': 'ზომა ეკრანზე',
  'set.page.48': 'ამ მოწყობილობისთვის. ლეპტოპზე „კომპაქტური" მეტს ატევს; შრიფტი 12px-ზე პატარა არ ხდება.',
  'set.page.49': 'ს/კ {companyId}',
  'set.page.50': 'სააბონენტო',
  'set.page.51': 'დახმარება',
  'set.page.52': 'მხარდაჭერის მოწვევა შენი ნებართვით',
  'set.page.53': 'მაღაზია',
  'set.page.54': 'PIN კოდი',
  'set.page.55': 'სისტემის ჩაკეტვა',
  'set.page.56': 'ფილიალები',
  'set.page.57': 'კიოსკის რეჟიმი',
  'set.page.58': 'თვითმომსახურების სალარო',
  'set.page.59': 'AI ფუნქციები',
  'set.page.60': 'პროდუქტის ამოცნობა ფოტოდან',
  'set.page.61': 'ლოიალობა',
  'set.page.62': 'ბონუსი და ფასის ჯგუფები კლიენტებისთვის',
  'set.page.63': 'გამორთ.',
  // 1.58
  'pg.title': 'ფასის ჯგუფები',
  'pg.sub': 'მყიდველს თავისი ფასი: მოლარე კალათაში მყიდველს აირჩევს და ფასები თავად გადაითვლება. მყიდველს ჯგუფში მხოლოდ თქვენ ჩასვამთ — მისი ფანჯრიდან.',
  'pg.empty': 'ჯერ ჯგუფი არ გაქვთ. დაამატეთ ქვემოთ — მაგალითად „ხელოსანი · 10%".',
  'pg.ruleWholesale': 'საბითუმო ფასი (სადაც არ აქვს — საცალო)',
  'pg.rulePct': 'ფასდაკლება {pct}% საცალოდან',
  'pg.customers': '{n} მყიდველი',
  'pg.off': 'გამორთული',
  'pg.offHint': 'ფასს აღარ ცვლის',
  'pg.belowCost': 'ამ ფასით {n} პროდუქტი თვითღირებულებაზე იაფად გაიყიდება.',
  'pg.new': 'ახალი ჯგუფი',
  'pg.presetWholesale': 'საბითუმო',
  'pg.presetWholesaleName': 'საბითუმო',
  'pg.presetMaster': 'ხელოსანი · 10%',
  'pg.presetMasterName': 'ხელოსანი',
  'pg.name': 'სახელი',
  'pg.rule': 'წესი',
  'pg.ruleWholesaleShort': 'საბითუმო ფასი',
  'pg.rulePctShort': 'ფასდაკლება %',
  'pg.pct': 'ფასდაკლება, %',
  'pg.add': 'დამატება',
  'pg.added': 'ჯგუფი დაემატა',
  'pg.saved': 'შენახულია',
  'pg.edit': 'შეცვლა',
  'pg.save': 'შენახვა',
  'pg.cancel': 'გაუქმება',
  'pg.switch': '{name} — ჩართვა ან გამორთვა',
  'pg.errName': 'სახელი 1-დან 40 სიმბოლომდე',
  'pg.errPct': 'ფასდაკლება 0-ზე მეტი და 100-ზე ნაკლები, მაქსიმუმ ორი ათწილადით',
  'set.page.64': 'ფერები და ზომა ამ მოწყობილობაზე',
  'set.page.65': 'დილის ანგარიში',
  'set.page.66': 'გუშინდელი დღე ელფოსტაზე, 08:00',
  'set.page.67': 'მარტივი რეჟიმი',
  'set.page.68': 'რა ჩანს ეკრანზე — ნისია, ზომები, ფასდაკლება…',
  'set.page.69': '{hiddenFeatures} დამალ.',
  'set.page.70': 'ყველა ჩანს',
  'set.page.71': 'კასაში დასატოვებელი',
  'set.page.72': 'ხურდა შემდეგი ცვლისთვის',
  'set.page.73': 'ინტეგრაციები',
  'set.page.74': 'ზედნადებები და Z-ანგარიშები',
  'set.page.75': 'ფისკალიზაცია',
  'set.page.76': 'QR-გადახდა',
  'set.page.77': 'Keepz — ტერმინალის გარეშე',
  'set.page.78': 'ელექტრო სასწორი',
  'set.page.79': 'ვიდეო-კამერები',
  'set.page.80': 'მითითებულია',
  'set.page.81': 'მონაცემები',
  'set.page.82': 'ასლში შენი მაღაზიის მონაცემები ხვდება. პაროლები და გასაღებები მასში არ ინახება.',
  'set.page.83': 'საერთო კატალოგი',
  'set.page.84': 'მონაცემების ასლი',
  'set.page.85': 'ჩამოტვირთვა და აღდგენა',
  'set.page.86': 'ანგარიშის წაშლა',
  'set.page.87': 'მაღაზიის და მონაცემების წაშლის მოთხოვნა',
  'set.page.88': 'პარამეტრები',
  'set.page.89': 'მაღაზია, ინტეგრაციები და მონაცემები',
  'set.page.90': 'პარამეტრების განყოფილებები',
  'set.restore.1': 'ვთვლი…',
  'set.restore.2': 'ფაილი ვერ წაიკითხა',
  'set.restore.3': 'აღდგა {added} ჩანაწერი, {failed} ვერ',
  'set.restore.4': 'აღდგა {added} ჩანაწერი',
  'set.restore.5': 'ყველაფერი უკვე ადგილზე იყო — ახალი არაფერი დაემატა',
  'set.restore.6': 'აღდგენა შეწყდა',
  'set.restore.7': 'მონაცემების აღდგენა',
  'set.restore.8': 'არსებულ მონაცემს არაფერი ემუქრება',
  'set.restore.9': 'აღდგენა მხოლოდ ',
  'set.restore.10': 'დაკარგულ',
  'set.restore.11': ' ჩანაწერებს აბრუნებს. რაც დღეს ბაზაშია, არ იცვლება და არ იშლება. ორჯერ გაშვებაც უსაფრთხოა.',
  'set.restore.12': 'აირჩიე ასლის ფაილი — ',
  'set.restore.13': ' ან მისგან ამოღებული ',
  'set.restore.14': 'იკითხება…',
  'set.restore.15': 'ფაილის არჩევა',
  'set.restore.16': 'ასლის თარიღი: ',
  'set.restore.17': 'დაემატება ',
  'set.restore.18': ' ჩანაწერი.',
  'set.restore.19': ' უკვე ადგილზეა და ხელუხლებელი დარჩება ',
  'set.restore.20': 'ცხრილი',
  'set.restore.21': 'ფაილში',
  'set.restore.22': 'აღდგა',
  'set.restore.23': 'დაემატება',
  'set.restore.24': 'უცვლელი',
  'set.restore.25': 'მიმდინარეობს…',
  'set.restore.26': 'დასრულდა — აღდგა ',
  'set.restore.27': 'RS.GE-ის, ფისკალურის და AI-ის პაროლები ასლში არ იყო — შეიყვანე ხელახლა პარამეტრებში.',
  'set.restore.28': 'ყოველთვიური ხარჯები (ქირა, ხელფასი…) ხელახლა დაამატე „ხარჯებში" — უკვე ჩაწერილი თვეები აღდგა.',
  'set.restore.recordOnly': 'ეს ფურცლები ასლში შენი ჩანაწერისთვისაა — აღდგენა მათ თავიდან არ ქმნის:',
  'set.restore.29': 'ნაწილი ვერ აღდგა',
  'set.restore.30': 'უცნობი მიზეზი',
  'set.restore.31': 'დანარჩენი აღდგა. ხელახლა გაშვება უსაფრთხოა — რაც შევიდა, აღარ გაორმაგდება.',
  'set.restore.32': 'აღსადგენი არაფერია',
  'set.restore.33': 'აღდგენა ({totalAdd})',
  'set.qr.1': 'Integrator ID არ არის UUID',
  'set.qr.2': 'Receiver ID არ არის UUID',
  'set.qr.3': 'შენახვა ვერ მოხერხდა',
  'set.qr.4': 'Keepz-ის პარამეტრები შენახულია — სალაროში „QR" ჩართულია',
  'set.qr.5': 'შენახულია',
  'set.qr.6': 'გასაღები ვერ შეიქმნა',
  'set.qr.7': 'ახალი გასაღები შეიქმნა — საჯარო ნაწილი Keepz-ს გადაეცი',
  'set.qr.8': 'დაკოპირდა',
  'set.qr.9': 'ვერ დაკოპირდა — მონიშნე და დააკოპირე ხელით',
  'set.qr.10': 'წაშლა ვერ მოხერხდა',
  'set.qr.11': 'Keepz გამორთულია',
  'set.qr.12': 'QR-გადახდა (Keepz)',
  'set.qr.13': 'მყიდველი ტელეფონით იხდის — ტერმინალის გარეშე',
  'set.qr.14': ' ჩართულია',
  'set.qr.15': 'სალაროში „ბარათი → QR" აჩვენებს კოდს, რომელსაც მყიდველი ბანკის ნებისმიერი აპლიკაციით ასკანერებს; გადახდისთანავე გაყიდვა თავისით იხურება. ფული Keepz-ის გავლით შენს ანგარიშზე მოდის — ანგარიშგებაში ბარათივით ითვლება, ცალკე სვეტით „QR (Keepz)".',
  'set.qr.16': 'დარეგისტრირდი ბიზნესად ',
  'set.qr.17': '-ზე და მოითხოვე API ინტეგრაცია.',
  'set.qr.18': 'ქვემოთ ჩააგდე, რასაც მოგცემენ: ',
  'set.qr.19': ' (ფილიალის) და ',
  'set.qr.20': 'მათი საჯარო გასაღები',
  'set.qr.21': '„გასაღების შექმნა" — და ',
  'set.qr.22': 'ჩვენი საჯარო გასაღები',
  'set.qr.23': ' გადაეცი Keepz-ს.',
  'set.qr.24': ' იტვირთება…',
  'set.qr.25': 'Keepz-ის identifier',
  'set.qr.26': 'Receiver ID (ფილიალი)',
  'set.qr.27': 'Keepz-ის საჯარო გასაღები (RSA)',
  'set.qr.28': '-----BEGIN PUBLIC KEY----- … ან base64',
  'set.qr.29': 'ჩვენი საჯარო გასაღები — Keepz-ს გადაეცი',
  'set.qr.30': 'ახლის შექმნა',
  'set.qr.31': 'გასაღების შექმნა',
  'set.qr.32': ' კოპირება',
  'set.qr.33': 'ჯერ არ არის. საიდუმლო ნაწილი ბაზაში რჩება და ბრაუზერამდე არასდროს აღწევს.',
  'set.qr.34': '„ახლის შექმნა" ძველს აუქმებს — Keepz-ს ახალიც უნდა გადასცე.',
  'set.qr.35': 'საკომისიოს იხდის',
  'set.qr.36': 'მაღაზია',
  'set.qr.37': 'მყიდველი',
  'set.qr.38': 'ორივე',
  'set.qr.39': 'სატესტო რეჟიმი (gateway.dev.keepz.me)',
  'set.qr.40': ' შენახვა',
  'set.qr.41': ' გამორთვა',
  'set.rsge.1': 'შეიყვანეთ სერვის მომხმარებელი და პაროლი',
  'set.rsge.2': 'შენახვა ვერ მოხერხდა',
  'set.rsge.3': 'RS.GE მონაცემები შენახულია — ახლა შეამოწმე კავშირი',
  'set.rsge.4': '✓ RS.GE კავშირი მუშაობს!',
  'set.rsge.5': 'ჯერ შეინახე სერვის მომხმარებელი',
  'set.rsge.6': 'მომხმარებელი ან პაროლი არასწორია',
  'set.rsge.7': 'კავშირი ვერ შედგა',
  'set.rsge.8': 'მოთხოვნა ვერ შესრულდა',
  'set.rsge.9': 'RS.GE ინტეგრაცია',
  'set.rsge.10': 'ზედნადებების ავტომატური მიღება საწყობში',
  'set.rsge.11': ' დაკავშირებულია',
  'set.rsge.12': 'rs.ge-ზე შექმენი ',
  'set.rsge.13': 'სერვის მომხმარებელი',
  'set.rsge.14': ' (მომხმარებლების მართვა → სერვის მომხმარებლები) და შეიყვანე აქ — მომწოდებლების ზედნადებები ავტომატურად ჩამოვა.',
  'set.rsge.15': 'მაგ. myshop_service',
  'set.rsge.16': 'სერვის პაროლი',
  'set.rsge.17': '•••••••• (შენახულია — შეცვლისთვის აკრიფე ახალი)',
  'set.rsge.18': 'კავშირის შემოწმება',
  'set.rsge.19': 'სალარო აპარატის Z-ანგარიშები RS.GE-დან (ბოლო 90 დღე)',
  'set.rsge.20': 'Z-ანგარიშები',
  'set.rsge.21': 'თუ წერია „მომხმარებელი ან პაროლი არასწორია“ — rs.ge-ზე სერვის მომხმარებელს უნდა ჰქონდეს უფლება: დამატებითი სერვისები → სალ. აპარატების დეტალური Z ინფორმაცია.',
  'set.rsge.22': 'RS.GE-მ ვერაფერი დააბრუნა — ბოლო 90 დღეში Z-ანგარიში არ არის',
  'set.rsge.23': 'ეს ნორმალურია, თუ სალარო აპარატი არ არის დარეგისტრირებული ამ საიდენტიფიკაციო ნომერზე.',
  'set.rsge.26': 'თარიღი',
  'set.rsge.27': 'აპარატი',
  'set.rsge.28': 'ჩეკი',
  'set.rsge.29': 'ნაღდი',
  'set.rsge.30': 'ბარათი',
  'set.rsge.31': 'სულ',
  'set.rsge.32': 'ტექნიკური დეტალები (RS.GE-ს პასუხი)',
  'set.del.1': 'ვერ მოხერხდა',
  'set.del.2': 'მოთხოვნა გაიგზავნა — დადასტურება ელფოსტაზე მოგივა',
  'set.del.3': 'მოთხოვნა გაუქმდა — მაღაზია რჩება',
  'set.del.4': 'ინტერნეტი არ არის — სცადე მოგვიანებით',
  'set.del.5': 'ანგარიშის წაშლა',
  'set.del.6': 'მაღაზიის და მისი ყველა მონაცემის წაშლის მოთხოვნა',
  'set.del.7': 'ანგარიშის წაშლას მხოლოდ მაღაზიის მფლობელი ითხოვს. თუ შენი შესვლის წაშლა გინდა, სთხოვე მფლობელს —',
  'set.del.8': ' თანამშრომლები → ანგარიშები',
  'set.del.9': ' იტვირთება…',
  'set.del.10': ' წაშლის მოთხოვნა გაგზავნილია — ',
  'set.del.11': 'მონაცემები სამუდამოდ წაიშლება არაუგვიანეს 3 თვისა. მანამდე მაღაზია მუშაობს როგორც ახლა. თუ გადაიფიქრე, გააუქმე — არაფერი დაიკარგება.',
  'set.del.12': ' მოთხოვნის გაუქმება',
  'set.del.13': 'იშლება მაღაზია, ყველა შესვლა, პროდუქტები, მარაგი, გაყიდვები, ცვლები, ხარჯები, კლიენტები და ნისიები, მომწოდებლები და ფოტოები.',
  'set.del.14': 'წაშლა ხდება ',
  'set.del.15': 'არაუგვიანეს 3 თვისა',
  'set.del.16': '; მანამდე შეგიძლია გააუქმო.',
  'set.del.17': 'ჯერ ჩამოტვირთე შენი მონაცემები —',
  'set.del.18': 'მონაცემების ასლი',
  'set.del.19': '— ან მოგვწერე ',
  'set.del.20': ' და Excel ფაილს გამოგიგზავნით.',
  'set.del.21': 'რა იშლება და რა რჩება ',
  'set.del.22': ' წაშლის მოთხოვნა',
  'set.del.23': 'მიზეზი (არასავალდებულო)',
  'set.del.24': 'მაგ. მაღაზია იხურება',
  'set.del.25': 'ნამდვილად ითხოვ მაღაზიის და ყველა მონაცემის წაშლას?',
  'set.del.26': ' დიახ, გაგზავნე მოთხოვნა',
  'set.del.27': 'არა',
  'set.catalog.1': '{n} პროდუქტს ფოტო დაემატა',
  'set.catalog.2': 'კატალოგში შესაბამისი ფოტო ვერ მოიძებნა',
  'set.catalog.3': '{n} პროდუქტი გაზიარდა საერთო კატალოგში',
  'set.catalog.4': 'გაზიარება ჩართულია',
  'set.catalog.5': '{n} პროდუქტი გამოთხოვილია',
  'set.catalog.6': 'გაზიარება გამორთულია',
  'set.catalog.7': 'საერთო კატალოგი',
  'set.catalog.8': 'შტრიხკოდით პროდუქტის სახელი და ფოტო თავისით ივსება',
  'set.catalog.9': 'როცა ახალ პროდუქტს ამატებ და შტრიხკოდს შეიყვან, სისტემა საერთო კატალოგში ეძებს — თუ იპოვა, ',
  'set.catalog.10': 'სახელი და ფოტო თავისით ივსება',
  'set.catalog.11': '. ფასს და რაოდენობას მაინც შენ წერ.',
  'set.catalog.12': 'რა გადის კატალოგში',
  'set.catalog.13': '✓ შტრიხკოდი',
  'set.catalog.14': '✗ ფასი',
  'set.catalog.15': '✓ დასახელება',
  'set.catalog.16': '✗ თვითღირებულება',
  'set.catalog.17': '✓ ფოტო',
  'set.catalog.18': '✗ მარაგი',
  'set.catalog.19': '✓ ერთეული',
  'set.catalog.20': '✗ მომწოდებელი',
  'set.catalog.21': 'ფასი და მარაგი ',
  'set.catalog.22': 'ვერ გავა',
  'set.catalog.23': ' — ეს ველები საერთო კატალოგში საერთოდ არ არსებობს.',
  'set.catalog.24': 'გაზიარებულია — ',
  'set.catalog.25': ' პროდუქტი (',
  'set.catalog.26': ' ფოტოთი)',
  'set.catalog.27': '{n} ახალი პროდუქტი გაზიარდა',
  'set.catalog.28': 'ყველაფერი უკვე გაზიარებულია',
  'set.catalog.29': 'ახლად დამატებულის გაზიარება',
  'set.catalog.30': 'ჩართვისას შენი ',
  'set.catalog.31': ' შტრიხკოდიანი პროდუქტი გაზიარდება. გამორთვისას ისინი ',
  'set.catalog.32': 'წაიშლება',
  'set.catalog.33': ' კატალოგიდან.',
  'set.catalog.34': ' პროდუქტს ფოტო აკლია',
  'set.catalog.35': 'შტრიხკოდით მოძებნის საერთო კატალოგში და შეავსებს',
  'set.catalog.36': 'ფოტოების შევსება',
  'set.catalog.37': ' მუშავდება…',
  'set.backup.1': 'ასლი ჩამოიტვირთა, მაგრამ {p1} ცხრილი ვერ წაიკითხა',
  'set.backup.2': 'ასლი ჩამოიტვირთა — {total} ჩანაწერი',
  'set.backup.3': 'ასლის შექმნა ვერ მოხერხდა',
  'set.backup.4': 'მონაცემების ასლი (Backup)',
  'set.backup.5': 'ყველა შენი მონაცემი ერთ ფაილად — Excel-ში გასახსნელად',
  'set.backup.6': 'ჩამოიტვირთება ZIP, რომელშიც არის ',
  'set.backup.7': ' (თითო ცხრილი თითო ფურცელზე — Excel-ით იხსნება ჩვენი პროგრამის გარეშეც) და',
  'set.backup.8': ' (სრული მონაცემი აღსადგენად). სულ ',
  'set.backup.9': ' ცხრილი.',
  'set.backup.10': 'პაროლები ფაილში არ შედის',
  'set.backup.11': 'RS.GE-ის, ფისკალურის და AI-ის გასაღებები, ასევე ადმინის PIN — განზრახ გამოტოვებულია. ფაილი ხშირად იგზავნება ბუღალტერთან ან ინახება USB-ზე.',
  'set.backup.12': 'ასლის ჩამოტვირთვა',
  'set.backup.13': 'აღდგენა',
  'set.backup.14': 'იკითხება: ',
  'set.backup.15': 'ბოლო ასლი: ',
  'set.backup.16': 'ასლი ჯერ არ გაგიკეთებია',
  'set.backup.17': '⚠️ რეკომენდაცია: ასლი თვეში ერთხელ მაინც ჩამოტვირთე და შეინახე ცალკე (USB, Google Drive, ან ელფოსტა საკუთარ თავს).',
  'set.backup.18': ' ასლიდან მხოლოდ იმას აბრუნებს, რაც დაკარგულია — არსებულ ჩანაწერს არ ცვლის და არ შლის. ანუ წაშლილს აღადგენს, მაგრამ შეცდომით შეცვლილ ფასს უკან არ აბრუნებს.',
  'set.backup.19': 'ეს ცხრილები ვერ წაიკითხა: ',
  'set.backup.20': 'დანარჩენი მონაცემი ჩამოიტვირთა. სცადე ხელახლა — თუ განმეორდა, მოგვწერე.',
  'set.loyalty.1': 'ბონუსი ჩართულია — 3%',
  'set.loyalty.2': 'ბონუსი გამორთულია',
  'set.loyalty.3': 'ბონუსი ჩართულია',
  'set.loyalty.4': 'პროცენტი 0–100 უნდა იყოს, მაგ. 3 ან 2.5',
  'set.loyalty.5': 'ბონუსი {parsed}%',
  'set.loyalty.6': 'ლოიალობა — ბონუსი',
  'set.loyalty.7': 'კლიენტს ყოველი ყიდვიდან ბონუსი ერიცხება და შემდეგ ყიდვაზე იხარჯება',
  'set.loyalty.8': 'ბონუსის პროცენტი',
  'set.loyalty.9': ' შენახვა',
  'set.loyalty.10': 'ჩაწერე რიცხვი 0-დან 100-მდე',
  'set.loyalty.11': 'მაგ. ₾50-ის ყიდვაზე კლიენტს დაერიცხება ₾{example}',
  'set.loyalty.12': 'როგორ მუშაობს',
  'set.loyalty.13': '· სალაროში მოლარე კლიენტს სახელით ან ტელეფონით ირჩევს — ნაღდზეც, ბარათზეც, ნისიაზეც.',
  'set.loyalty.14': '· ბონუსი ',
  'set.loyalty.15': 'ლარებშია',
  'set.loyalty.16': ' და ერიცხება იმაზე, რაც კლიენტმა რეალურად გადაიხადა — ბონუსით დაფარულზე ბონუსი არ ერიცხება; ნისიაზე — მხოლოდ ახლა გადახდილ ნაწილზე.',
  'set.loyalty.17': '· ბონუსის დახარჯვა მოლარის ფასდაკლების ლიმიტს ',
  'set.loyalty.18': 'არ ითვლის',
  'set.loyalty.19': ' — ეს კლიენტის ფულია, არა ფასდაკლება.',
  'set.loyalty.20': '· დაბრუნებისას ბონუსი პროპორციულად ბრუნდება (დახარჯული) და იჭრება (დარიცხული).',
  'set.loyalty.21': '· ყოველი მოძრაობა კლიენტის ბარათზე ჩანს (ნისია → კლიენტი → ბონუსი); შესწორება მხოლოდ მფლობელს შეუძლია.',
  'set.kiosk.1': 'კიოსკის რეჟიმი',
  'set.kiosk.2': 'Self-checkout — მომხმარებელი თვითონ სკანავს და იხდის',
  'set.kiosk.3': 'ბარათის ტერმინალი',
  'set.kiosk.4': 'კიოსკის ბარათით გაყიდვები ამ ტერმინალზე ჩაიწერება',
  'set.kiosk.5': 'ნაღდის მიღება',
  'set.kiosk.6': 'თანამშრომლის დახმარებით — მომხმარებელი თანხას თანამშრომელს გადასცემს',
  'set.kiosk.7': 'კიოსკიდან გამოსვლას PIN სჭირდება, ამ მაღაზიას კი ის ჯერ არ აურჩევია — გაშვებამდე აირჩიე.',
  'set.kiosk.8': ' გახსნა ახალ ფანჯარაში',
  'set.kiosk.9': 'კიოსკი ცალკე ფანჯარაში გადის (მეორე მონიტორზე გადაიტანე) — ეს კომპიუტერი ჩვეულებრივ აგრძელებს მუშაობას. რამდენიმე მოწყობილობასაც შეუძლია /kiosk-ის პარალელურად გახსნა.',
  'set.kiosk.10': ' ამ მოწყობილობის ჩაკეტვა კიოსკად',
  'set.kiosk.11': 'ცალკე ტაბლეტისთვის/კიოსკ-მოწყობილობისთვის: მთელი მოწყობილობა მხოლოდ კიოსკის ეკრანს აჩვენებს, გამოსვლას სისტემის PIN სჭირდება. გაყიდვისთვის ცვლა წინასწარ უნდა იყოს გახსნილი.',
  'set.fiscal.1': 'შეიყვანე API გასაღები',
  'set.fiscal.2': 'შენახვა ვერ მოხერხდა',
  'set.fiscal.3': 'kasa.ge მონაცემები შენახულია',
  'set.fiscal.4': 'წაშლა ვერ მოხერხდა',
  'set.fiscal.5': 'მონაცემები წაიშალა — ისევ ტესტ-რეჟიმი',
  'set.fiscal.6': '✓ მუშაობს ტესტ-რეჟიმში (რეალური kasa.ge კავშირი ჯერ არაა)',
  'set.fiscal.7': '✓ kasa.ge კავშირი მუშაობს!',
  'set.fiscal.8': 'კავშირი ვერ შედგა',
  'set.fiscal.9': 'ფისკალიზაცია (kasa.ge)',
  'set.fiscal.10': 'ღრუბლოვანი ჩეკები ლოკალური აპარატის ნაცვლად',
  'set.fiscal.11': ' კონფიგურირებულია',
  'set.fiscal.12': ' ტესტ-რეჟიმი',
  'set.fiscal.13': 'სანამ kasa.ge-ს რეალური მონაცემები არ არის შენახული, ჩეკები გაიცემა',
  'set.fiscal.14': 'ტესტ-რეჟიმში',
  'set.fiscal.15': ' (TEST-… ნომრებით, RS.GE-მდე არ აღწევს). ეს დემოსა და გაწყობისთვისაა — რეალური ფისკალიზაციისთვის საჭიროა kasa.ge-ს პარტნიორული წვდომა.',
  'set.fiscal.16': 'API გასაღები',
  'set.fiscal.17': '•••••••• (შენახულია — შეცვლისთვის აკრიფე ახალი)',
  'set.fiscal.18': 'ტერმინალის ID ',
  'set.fiscal.19': '— არასავალდ.',
  'set.fiscal.20': 'კავშირის ტესტი',
  'set.fiscal.21': ' წაშლა',
  'set.fiscal.dev.1': 'ფისკალური აპარატი',
  'set.fiscal.dev.2': 'შეერთებულია თუ არა სალაროს კომპიუტერთან',
  'set.fiscal.dev.3': 'გამორთულია. სალაროში „ფისკალური ჩეკის" გადამრთველი და ფისკალური გაფრთხილებები არ ჩანს — ჩეკს ისევ მაღაზიის აპარატი ან ბანკის სალარო ტერმინალი ბეჭდავს.',
  'set.fiscal.dev.4': 'ჩართულია. სალაროში ჩანს „ფისკალური ჩეკის" გადამრთველი და ჩეკი აპარატზე იგზავნება. ჩართე მხოლოდ მაშინ, როცა აპარატი ამ სალაროს კომპიუტერთან შეერთებულია.',
  'set.float.1': 'კასაში დასატოვებელი თანხა',
  'set.float.2': 'ხურდა შემდეგი ცვლისთვის — ცვლის დახურვისას',
  'set.float.3': 'გამორთვა',
  'set.float.4': 'ჩართვა',
  'set.float.5': 'თანხა ₾',
  'set.float.6': 'ცვლის დახურვისას აპი თავად შემოგთავაზებს: კასაში რჩება ',
  'set.float.7': ', დანარჩენი გააქვს — და ჩაიწერება, სად წავიდა (მფლობელს, ბანკში ან სხვა)',
  'set.float.8': 'თუ ნაკლებს დატოვებ ან ყველაფერს გაიტან, ჯერ შეგახსენებს — აკრძალვა არ არის',
  'set.float.9': 'შემდეგი ცვლა ამ თანხით გაიხსნება. სხვა ციფრი რომ ჩაწერონ, სხვაობა ჩაიწერება Z-რეპორტში, ჟურნალში და დილის ანგარიშში',
  'set.float.10': 'გამორთულია: დახურვისას აპი მთელ თანხას კასაში ტოვებს, თუ თავად არ შეცვლი. გატანის ჩაწერა ყოველთვის შეიძლება.',
  'set.float.11': 'ამ თანხას მაღაზიის მფლობელი ადგენს.',
  'set.report.1': 'წერილი ვერ გაიგზავნა',
  'set.report.2': 'ინტერნეტი არ არის — სცადე მოგვიანებით',
  'set.report.3': 'დილის ანგარიში',
  'set.report.4': 'ყოველ დილას 08:00-ზე — გუშინდელი დღე, მფლობელის ელფოსტაზე',
  'set.report.5': 'გამორთვა',
  'set.report.6': 'ჩართვა',
  'set.report.7': 'გაყიდვები, ბრუნვა და ',
  'set.report.8': 'წმინდა მოგება',
  'set.report.9': ' — ზუსტად ის, რასაც ბუღალტერია აჩვენებს',
  'set.report.10': 'ცვლები და მათი ',
  'set.report.11': 'სხვაობა',
  'set.report.12': ', დაუხურავი ცვლა',
  'set.report.13': 'სალაროდან გატანილი თანხა და მიზეზი',
  'set.report.14': 'გაყიდვადი პროდუქტი, რომელიც ამოიწურა ან თავდება',
  'set.report.15': 'ვის აქვს ნისია',
  'set.report.16': 'დღე, როცა არაფერი გაყიდულა, წერილი არ მოდის.',
  'set.report.17': ' გამომიგზავნე ახლა (გუშინდელი)',
  'set.report.18': 'დილის ანგარიშს მაღაზიის მფლობელი ჩართავს.',
  'set.branches.1': 'ფილიალები',
  'set.branches.2': 'მარაგი, ცვლები და გაყიდვები ფილიალების მიხედვით',
  'set.branches.3': ' დამატება',
  'set.branches.4': 'ფილიალის სახელი — მაგ. „საბურთალო“',
  'set.branches.5': 'მისამართი (არასავალდებულო)',
  'set.branches.6': ' შენახვა',
  'set.branches.7': ' გაუქმება',
  'set.branches.8': 'მთავარი',
  'set.branches.9': '● აქტიური',
  'set.branches.10': 'სახელი და მისამართი',
  'set.branches.11': 'წაშლა?',
  'set.branches.12': 'ფილიალის წაშლა',
  'set.branches.13': 'აქტიური ფილიალი ზედა პანელიდან ირჩევა — თითო მოწყობილობა თავის ფილიალს იმახსოვრებს. მარაგი, ცვლა და გაყიდვები არჩეულ ფილიალს მიეკუთვნება.',
  'set.branches.14': 'მეორე ფილიალის დამატებისას ზედა პანელში გამოჩნდება გადამრთველი და მარაგი ფილიალების მიხედვით გაიყოფა.',
  'set.simple.1': 'მარტივი რეჟიმი',
  'set.simple.2': '{hidden} დამალულია',
  'set.simple.3': 'ყველა ჩანს',
  'set.simple.4': 'ეკრანზე მხოლოდ ის ჩანს, რასაც მაღაზია იყენებს. სანამ თვითონ აირჩევ, ამას მაღაზიის ქცევა წყვეტს — ნებისმიერს ერთი დაჭერით დააბრუნებ.',
  'set.simple.5': 'დამალვა მონაცემს არ შლის — ნისიის ვალები, მოდელები და აქციები ადგილზე რჩება და ჩართვისთანავე ისევ გამოჩნდება.',
  'set.simple.6': 'ამას მაღაზიის მფლობელი ირჩევს.',
  'set.simple.7': 'შენი არჩევანი',
  'set.simple.8': ' · ავტომატურად ',
  'set.simple.9': 'გამოჩნდებოდა',
  'set.simple.10': 'დაიმალებოდა',
  'set.simple.11': 'ავტომატურზე დაბრუნება',
  'set.simple.12': 'ავტომატური',
  'set.simple.13': 'ჩანს',
  'set.simple.14': 'დამალულია',
  'set.simple.needs': 'საჭიროა „{name}“ — ჯერ ის ჩართე',
  'qr.card.title': 'QR მაგიდებზე',
  'qr.card.sub': 'სტუმარი მაგიდის QR-ით იძახებს მიმტანს, ითხოვს ანგარიშს და უკვეთავს მენიუდან — მიმტანი ადასტურებს.',
  'qr.card.versions': 'ჩართე, როცა ყველა სალარო და მიმტანის ტელეფონი MartePOS 1.69-ს აჩვენებს — ძველი ვერ დაინახავს სტუმრის მოთხოვნას.',
  'qr.card.off': 'გამორთულია — სტიკერი სტუმარს აჩვენებს „ეს QR აღარ მოქმედებს“.',
  'qr.card.stickers': 'სტიკერები',
  'qr.card.print': 'სტიკერების ბეჭდვა · {n}',
  'qr.card.open': 'გახსნა',
  'qr.card.rotate': 'ახალი QR',
  'qr.card.rotateAll': 'ყველა QR-ის შეცვლა',
  'qr.card.rotateAsk': '{name}-ის ძველი სტიკერი აღარ იმუშავებს — ახალი უნდა დაბეჭდო. შევცვალო?',
  'qr.card.rotateAllAsk': 'ყველა მაგიდის ძველი სტიკერი აღარ იმუშავებს — ყველა ახლიდან უნდა დაბეჭდო. შევცვალო?',
  'qr.card.rotated': 'QR შეიცვალა — დაბეჭდე ახალი სტიკერი',
  'qr.card.yes': 'შეცვლა',
  'qr.card.noTables': 'ამ ფილიალში მაგიდები ჯერ არ არის',
  'qr.card.menu': 'მენიუ სტუმრისთვის',
  'qr.card.menuCount': 'მენიუში {n} კერძი, {m} — ინგლისური სახელის გარეშე',
  'qr.card.menuAuto': 'ავტო',
  'qr.card.menuOn': 'ჩანს',
  'qr.card.menuOff': 'დამალული',
  'qr.card.menuAutoHint': 'ავტო: ჩანს, თუ სამზარეულოს ან ბარის კატეგორიაა',
  'qr.card.inMenu': 'მენიუში',
  'qr.card.nameEn': 'ინგლისური სახელი',
  'qr.card.notListed': 'არ ჩანს',
  'qr.card.autoAddon': 'არ ჩანს — თავისით ემატება ანგარიშს',
  'qr.card.saved': 'შენახულია',
  'qr.card.loadFailed': 'მენიუ ვერ ჩაიტვირთა — სცადე თავიდან',
  'set.ai.1': 'Anthropic API key იწყება "sk-ant-"-ით — შეამოწმე',
  'set.ai.2': 'შენახვა ვერ მოხერხდა',
  'set.ai.3': 'AI key შენახულია — "AI სწრაფი დამატება" ჩართულია საწყობში',
  'set.ai.4': 'წაშლა ვერ მოხერხდა',
  'set.ai.5': 'AI key წაიშალა',
  'set.ai.6': 'AI ფუნქციები',
  'set.ai.7': 'პროდუქტის ამოცნობა ფოტოდან — საკუთარი Anthropic key',
  'set.ai.8': ' ჩართულია',
  'set.ai.9': 'შეიყვანე შენი ',
  'set.ai.10': ' (console.anthropic.com) და საწყობში გაჩნდება „AI სწრაფი დამატება" — პროდუქტის ფოტოდან სახელი, კატეგორია და შტრიხკოდი ავტომატურად შეივსება. ხარჯი შენი ანგარიშიდან იჭრება (~1-2 თეთრი სკანზე).',
  'set.ai.11': '•••••••• (შენახულია — შეცვლისთვის აკრიფე ახალი)',
  'set.ai.12': ' წაშლა',
  'set.scale.1': 'ელექტრო სასწორი',
  'set.scale.2': 'კაბელით ან ეტიკეტით',
  'set.scale.3': 'სასწორი ბეჭდავს შტრიხკოდს წონით/ფასით; სისტემა მას სკანირებისას ავტომატურად შლის. პროდუქტს მიანიჭე ',
  'set.scale.4': 'PLU კოდი',
  'set.scale.5': ' საწყობში — ის ნომერი, რომელიც სასწორს შტრიხკოდში ჩააქვს (ეტიკეტზე ხშირად „კოდი", არა PLU — ღილაკის ნომერი).',
  'set.scale.6': 'პრეფიქსები ',
  'set.scale.7': '— ეტიკეტის პირველი 2 ციფრი, მძიმით',
  'set.scale.8': 'PLU-ს სიგრძე ეტიკეტზე',
  'set.scale.10': 'რას შიფრავს ეტიკეტი',
  'set.scale.11': 'წონას (გრამები)',
  'set.scale.12': 'ფასს (თეთრები)',
  'set.scale.13': 'არ იცი? სასწორის ერთი ეტიკეტის ფოტო საკმარისია დასადგენად — ჰკითხე მხარდაჭერას.',
  'set.camera.1': 'კამერის ბმული შენახულია',
  'set.camera.2': 'ვიდეო-კამერები (CCTV)',
  'set.camera.3': 'მოვლენების ჟურნალიდან ჩანაწერზე გადასვლა',
  'set.camera.4': 'ბუღალტერიის ',
  'set.camera.5': '„მოვლენები"',
  'set.camera.6': ' ჩანართი ყველა მოვლენას კამერის ზუსტ დროს აჩვენებს. თუ შენს NVR-ს/კამერას აქვს ბრაუზერის ბმული დროის პარამეტრებით, ჩაწერე შაბლონად და „🎥" ღილაკი პირდაპირ ჩანაწერზე გადავა.',
  'set.camera.7': 'ბმულის შაბლონი ',
  'set.camera.8': '— არასავალდებულო',
  'set.camera.9': 'ჩასანაცვლებლები: ',
  'set.camera.10': '. ცარიელი = მხოლოდ დროის ჩვენება/კოპირება.',
  'support.card.1': 'მოთხოვნა გაეგზავნა — მხარდაჭერა მალე დაგიკავშირდება',
  'support.card.2': 'ვერ გაიგზავნა — უთხარი ეს კოდი მხარდაჭერას',
  'support.card.3': 'მოთხოვნა გაიგზავნა — მხარდაჭერა მალე დაგიკავშირდება',
  'support.card.4': 'წვდომა დაიხურა',
  'support.card.5': 'დახმარება',
  'support.card.6': 'MartePOS-ის მხარდაჭერას შენს მაღაზიაში შენი ნებართვით უშვებ — დროებით',
  'support.card.7': ' იტვირთება…',
  'support.card.8': ' მხარდაჭერა ახლა შენს მაღაზიაშია',
  'support.card.9': 'ნახვა და შესწორება',
  'support.card.10': 'მხოლოდ ნახვა',
  'support.card.11': ' · დარჩა ',
  'support.card.12': ' · შევიდა ',
  'support.card.13': ' წვდომის შეწყვეტა ახლავე',
  'support.card.14': 'დახმარების კოდი — უთხარი მხარდაჭერას ან უბრალოდ გაგზავნე',
  'support.card.15': 'კოდის კოპირება',
  'support.card.16': 'დაკოპირდა',
  'support.card.17': 'კოპირება',
  'support.card.18': 'კოდი ერთხელ გამოჩნდება. თუ არავინ გამოიყენა, ',
  'support.card.19': '-ზე უქმდება.',
  'support.card.20': 'მოთხოვნა გაგზავნილია',
  'support.card.21': 'დახმარების მოთხოვნა ღიაა',
  'support.card.22': 'მხარდაჭერა მას საკუთარ კონსოლში ხედავს — კოდის თქმა აღარ გჭირდება.',
  'support.card.23': 'მოქმედებს ',
  'support.card.24': '-მდე.',
  'support.card.25': 'გაგზავნილია მხარდაჭერისთვის',
  'support.card.26': 'გაგზავნა მხარდაჭერისთვის',
  'support.card.27': 'რა გაწუხებს? (არასავალდებულო)',
  'support.card.28': 'მაგ. ფასები აირია, პრინტერი არ ბეჭდავს…',
  'support.card.29': 'უფლება',
  'support.card.30': 'რისი უფლება მისცე',
  'support.card.31': 'პროდუქტები, ფასები, კატეგორიები, მომწოდებლები, პარამეტრები. ყოველი ცვლილება აქ ჩაიწერება.',
  'support.card.32': 'ყველაფერს ხედავს, ვერაფერს ცვლის.',
  'support.card.33': 'რამდენი ხნით',
  'support.card.34': 'რასაც აირჩევ, მხარდაჭერა მაინც ',
  'support.card.35': 'ვერ',
  'support.card.36': ' გაყიდის, ვერ დააბრუნებს, ვერ შეეხება სალაროს, ვალებს, ბონუსებს, ვერ ნახავს პაროლებს (RS.GE, ფისკალური) და ვერ შექმნის ახალ ანგარიშს. ნებისმიერ დროს შეწყვეტ.',
  'support.card.37': ' დახმარების გაგზავნა',
  'support.card.38': 'მოთხოვნა პირდაპირ მხარდაჭერას მივა — კოდის კარნახი აღარ გჭირდება.',
  'support.card.39': ' ან კოდი მომეცი — ტელეფონით ვეტყვი',
  'support.card.40': 'პრინტერი, სკანერი ან ფისკალური?',
  'support.card.41': ' მოწყობილობებს მონაცემებიდან ვერ დავინახავთ — გახსენი',
  'support.card.42': '„Share this screen" → მიიღე კოდი და გვითხარი. შენს ეკრანს მხოლოდ შენი თანხმობით ვნახავთ.',
  'support.card.43': 'ისტორია',
  'support.card.44': 'მხარდაჭერას არაფერი შეუცვლია.',
  'support.banner.1': 'მხარდაჭერის სესია დასრულდა',
  'support.banner.2': 'მხარდაჭერის დრო ამოიწურა',
  'support.banner.3': 'მხარდაჭერის რეჟიმი · ',
  'support.banner.4': 'ნახვა და შესწორება',
  'support.banner.5': 'მხოლოდ ნახვა',
  'support.banner.6': 'დარჩა ',
  'support.banner.7': ' · ფული, სალარო და პაროლები დაკეტილია',
  'support.banner.8': ' დასრულება',
  'support.banner.9': 'მხარდაჭერის წვდომა დაიხურა',
  'support.banner.10': 'მხარდაჭერა შენს მაღაზიაშია · დარჩა ',
  'support.banner.11': ' შეწყვეტა',
  'bill.pay.1': 'ვერ დაკოპირდა — მონიშნე და დააკოპირე ხელით',
  'bill.pay.2': '{label} — კოპირება',
  'bill.pay.3': 'დაკოპირდა',
  'bill.pay.4': 'კოპირება',
  'bill.pay.5': 'გამოწერა ამ აპიდან არ იმართება.',
  'bill.pay.6': ' იტვირთება…',
  'bill.pay.7': 'მივიღეთ — ჩარიცხვის დადასტურებისთანავე ვადა თავისით გაგრძელდება',
  'bill.pay.8': 'გადახდის რეკვიზიტები ჯერ არ არის მითითებული — დაგვიკავშირდით.',
  'bill.pay.9': 'პერიოდი',
  'bill.pay.10': '1 თვე',
  'bill.pay.11': 'ყოველთვიური',
  'bill.pay.12': '1 წელი',
  'bill.pay.13': '{n} თვე საჩუქრად',
  'bill.pay.14': '12 თვე',
  'bill.pay.15': 'ვადა: ',
  'bill.pay.16': 'საბანკო გადარიცხვა',
  'bill.pay.17': 'მიმღები',
  'bill.pay.18': 'თანხა',
  'bill.pay.19': 'დანიშნულება — აუცილებლად',
  'bill.pay.20': 'დანიშნულებაში კოდი ',
  'bill.pay.21': ' ჩაწერე — ასე ამონაწერში ვხედავთ, რომ ეს შენი მაღაზიაა.',
  'bill.pay.22': 'შეტყობინება მიღებულია',
  'bill.pay.23': '. ჩარიცხვის დადასტურებისთანავე ვადა თავისით გაგრძელდება.',
  'bill.pay.24': 'რომელ ანგარიშზე ჩარიცხე?',
  'bill.pay.25': ' ინვოისი (PDF)',
  'bill.pay.26': 'ხელახლა შეტყობინება',
  'bill.pay.27': 'გადავრიცხე ₾{amount}',
  'bill.pay.28': 'გადახდას მაღაზიის მფლობელი ადასტურებს.',
  'bill.pay.29': 'გამოწერის გადახდა',
  'bill.banner.1': 'შეტყობინება მიღებულია — ველოდებით ჩარიცხვის დადასტურებას',
  'bill.banner.2': 'საცდელი პერიოდი — დარჩა {daysLeft} დღე',
  'bill.banner.3': 'საცდელი დასრულდა — {lockInDays} დღეში მაღაზია ჩაიკეტება',
  'bill.banner.4': 'გამოწერა დღეს მთავრდება',
  'bill.banner.5': 'გამოწერა მთავრდება — დარჩა {daysLeft} დღე',
  'bill.banner.6': 'გამოწერის ვადა გადაცილებულია {daysOver} დღით',
  'bill.banner.7': 'დეტალები',
  'bill.banner.8': 'გადახდა',
  'tools.1': 'მხოლოდ ფოტოების ატვირთვაა შესაძლებელი',
  'tools.2': 'ფოტოების ოპტიმიზაცია მიმდინარეობს...',
  'tools.3': 'ოპტიმიზაცია დასრულდა!',
  'tools.4': 'ჯერ უნდა დააოპტიმიზო ფოტოები',
  'tools.5': 'მზადდება ZIP ფაილი...',
  'tools.6': 'ZIP ფაილი ჩამოიტვირთა!',
  'tools.7': 'შეცდომა ZIP გენერაციის დროს',
  'tools.8': 'ფოტოების ოპტიმიზატორი',
  'tools.9': 'დააპატარავე ფოტოები ატვირთვამდე სივრცის დასაზოგად',
  'tools.10': 'გასუფთავება',
  'tools.11': ' ოპტიმიზაცია...',
  'tools.12': 'მთლიანი ოპტიმიზაცია',
  'tools.13': ' იქმნება ZIP...',
  'tools.14': ' ჩამოტვირთე ZIP',
  'tools.15': 'გილოცავთ! თქვენ დაზოგეთ ',
  'tools.16': ' სივრცე.',
  'tools.17': 'ჩააგდე ფოტოები აქ ან აირჩიე',
  'tools.18': 'დიდი რაოდენობით ატვირთვა დაშვებულია',
  'tools.19': 'მუშავდება...',
  'tools.20': 'ჩამოტვირთვა',
  'density.picker.1': 'ზომა ეკრანზე',
  'theme.toggle.1': 'ღია',
  'theme.toggle.2': 'მუქი',
  'set.announce.1': 'ანონსის დახურვა',
  'set.report.sent': 'გაიგზავნა: {to}',
  'set.report.sentQuiet': 'გაიგზავნა: {to} — გუშინ გაყიდვა არ ყოფილა',
  'set.scale.digits': '{n} ციფრი',
  'set.rsge.zCount': 'RS.GE-ში დაფიქსირებული {n} Z-ანგარიში',
  // 123 — the owner's Telegram (components/settings/telegram-card.tsx)
  'set.page.tg': 'ანგარიშები და კასა ტელეფონში',
  'set.tg.sub': 'დილის ანგარიში, ცვლის დახურვა და კასის მდგომარეობა — Telegram-ში',
  'set.tg.ownerOnly': 'Telegram-ს მაღაზიის მფლობელი აკავშირებს.',
  'set.tg.chats': 'მიბმული ჩატები · {n}/{max}',
  'set.tg.none': 'ჯერ არცერთი ჩატი არ არის მიბმული.',
  'set.tg.linkedOn': 'მიბმულია {date}',
  'set.tg.remove': 'მოხსნა',
  'set.tg.removeSure': 'მოვხსნა?',
  'set.tg.removed': '„{label}" მოიხსნა — იქ აღარაფერი მივა',
  'set.tg.connect': 'Telegram-ის დაკავშირება',
  'set.tg.connectMore': 'კიდევ ერთი ჩატის დამატება',
  'set.tg.open': 'Telegram-ის გახსნა',
  'set.tg.codeHint': 'ან Telegram-ში მოძებნე @{bot} და გაუგზავნე:',
  'set.tg.waiting': 'ველოდები Telegram-ს — ბმული 10 წუთი მოქმედებს',
  'set.tg.linked': 'Telegram დაკავშირდა: {label}',
  'set.tg.pushes': 'თავისით გამოგზავნის',
  'set.tg.morning': 'დილის ანგარიში',
  'set.tg.morningSub': '08:00 — გუშინდელი დღე: გაყიდვა, მოგება, ცვლები, რა იწურება',
  'set.tg.shift': 'ცვლის დახურვა',
  'set.tg.shiftSub': 'მოლარე, ნაღდი, ბარათი და კასის სხვაობა — დახურვისთანავე',
  'set.tg.evening': 'საღამოს მდგომარეობა',
  'set.tg.eveningSub': '21:00 — დღის გაყიდვა, რამდენია კასაში, რამდენი ბარათზე',
  'set.tg.loss': '🚨 დანაკარგების კონტროლი',
  'set.tg.lossSub': 'იმწამსვე: კალათიდან ამოღება გადახდის ფანჯრის შემდეგ ან ₾100-დან, ფასის შეცვლა სალაროში, ფასდაკლება 10%-დან, დაბრუნება, სალაროდან გატანა, ცვლის ნაკლები თანხით გახსნა',
  'set.tg.week': '📅 კვირის ანგარიში',
  'set.tg.weekSub': 'ორშაბათს 08:00 — გასული კვირა წინასთან: შემოსავალი, მოგება, დღეები, ყველაზე გაყიდვადი',
  'set.tg.waybill': 'ახალი ზედნადები RS.GE-დან',
  'set.tg.order': 'ახალი ონლაინ შეკვეთა',
  'set.tg.orderSub': 'მყიდველმა საიტზე შეუკვეთა: ვინ, ტელეფონი, რა, რამდენი. შეკვეთა მარაგს მანამ იკავებს, სანამ არ დაადასტურებ ან გააუქმებ',
  'set.tg.waybillSub': 'მომწოდებლის ზედნადები გააქტიურდა და ჯერ არ მიგიღია: ვინ, რამდენი, ნომერი. 15 წუთში ერთხელ ამოწმებს; მხოლოდ თუ RS.GE დაკავშირებულია',
  'set.tg.sale': 'ყოველი გაყიდვა',
  'set.tg.saleSub': 'ყოველ ჩეკზე შეტყობინება — დიდ მაღაზიაში ბევრი იქნება',
  'set.tg.commands': 'ბრძანებები ბოტში',
  'set.tg.cmdStatus': 'დღეს აქამდე: გაყიდვა, ნაღდი, ბარათი, კასა',
  'set.tg.cmdCash': 'რამდენია კასაში ახლა',
  'set.tg.cmdYesterday': 'გუშინდელი ანგარიში',
  'set.tg.cmdStock': 'რა იწურება',
  'set.tg.cmdDebts': 'ვის რამდენი მართებს, რა გვმართებს მომწოდებლებთან, ყოველთვიური ხარჯები — და WhatsApp შეხსენება მოვალეს',
  'set.tg.cmdWeek': '7 დღე წინა კვირასთან',
  'set.tg.cmdFind': 'პროდუქტის ფასი და მარაგი — პირად ჩატში საკმარისია სახელის ან შტრიხკოდის დაწერა',
  'set.tg.cmdStop': 'ამ ჩატის გამოთიშვა',
  'set.tg.test': 'სატესტო შეტყობინება ახლა',
  'set.tg.testSent': 'გაიგზავნა {n} ჩატში',
  'set.tg.err.owner': 'Telegram-ს მხოლოდ მაღაზიის მფლობელი აკავშირებს',
  'set.tg.err.bot': 'ბოტი ჯერ არ არის ჩართული — დაგვიკავშირდი',
  'set.tg.err.full': 'უკვე 3 ჩატია მიბმული — ახლისთვის ჯერ ერთი მოხსენი',
  'set.tg.err.none': 'ჯერ ჩატი არ არის მიბმული',
  'set.tg.err.send': 'Telegram-მა შეტყობინება ვერ მიიღო — სცადე ცოტა ხანში',
  'set.tg.err.generic': 'ვერ მოხერხდა — სცადე ცოტა ხანში',

  // 130 — repairs
  'feat.repairs': 'შეკეთება',
  'feat.repairs.shows': '„შეკეთება" მენიუში — ნივთის მიღება, სტატუსები, გადახდა სალაროში',
  'feat.why.repairsOff': 'ჩართე, თუ ნივთებს შესაკეთებლად იღებ',
  'feat.store': 'ონლაინ შეკვეთები',
  'feat.store.shows': '„ონლაინ შეკვეთები" მენიუში — საიტიდან შემოსული შეკვეთები, დადასტურება, გაყიდვა',
  'feat.why.storeOff': 'მაღაზიას საიტი ჯერ არ აქვს — საიტს MartePOS რთავს',
  'feat.askQty': 'რაოდენობის კითხვა',
  'feat.askQty.shows': 'ცალობით პროდუქტზე დაჭერისას სალარო იკითხავს „რამდენი?" — მაგ. კვერცხი 30 (წონით პროდუქტზე ყოველთვის კითხულობს)',
  'feat.why.poultry': 'ქათმის ნაწარმის მაღაზია — კვერცხი ათეულით და კასეტით იყიდება',
  'feat.why.askQtyOff': 'ჩართე, თუ ცალობით პროდუქტს ხშირად რამდენიმეს ერთად ყიდი',
  'feat.changeTetri': 'ხურდის თეთრები',
  'feat.changeTetri.shows': 'ნაღდით გადახდისას — ღილაკი, როცა ხურდა 5 თეთრზე არ მრგვალდება (19 თეთრი — კი, 25 — არა): რამდენი თეთრი დარჩა ან დავამატეთ. ცვლის დახურვა ამას ითვლის; გაყიდვის ჯამი, ჩეკი და RS.GE ზუსტი რჩება',
  'feat.prepaid': 'სასაჩუქრე ბარათი და წინასწარი გადახდა',
  'feat.prepaid.shows': 'სალაროში — სასაჩუქრე ბარათის გაყიდვა, წინასწარი თანხის მიღება (შეკვეთა, გადადებული ნივთი) და მათით გადახდა. ჩართე მხოლოდ მაშინ, როცა მაღაზიის ყველა სალარო 1.57-ს აჩვენებს',
  'feat.why.prepaidOff': 'ჩართე, თუ ყიდით სასაჩუქრე ბარათებს ან იღებთ წინასწარ თანხას შეკვეთაზე',
  'feat.club': 'მყიდველთა კლუბი',
  'feat.club.shows': 'რეგისტრაციის პოსტერი, კლუბის ბარათი სალაროში, კლუბის ფასი პროდუქტზე. ჩართე მხოლოდ მაშინ, როცა მაღაზიის ყველა სალარო 1.63-ს აჩვენებს',
  'feat.why.clubOff': 'ჩართე, როცა ყველა სალარო 1.63-ს აჩვენებს და კლუბის გაშვება გინდა',
  'feat.fitment': '„ერგება" და OEM ნომრები',
  'feat.fitment.shows': 'პროდუქტის ბარათზე — რომელ მანქანას ან ტელეფონს ერგება და მისი OEM / შემცვლელი ნომრები; Excel-ში — ორი სვეტი. სალარო ამ ჩანაწერებით ყოველთვის პოულობს',
  'feat.why.fitmentData': 'პროდუქტებს უკვე უწერიათ „ერგება" ან OEM ნომერი',
  'feat.why.fitmentTemplate': 'ავტონაწილების ან აქსესუარების მაღაზიაა',
  'feat.why.fitmentOff': 'ჩართე, თუ ყიდით ნაწილებს მანქანისთვის ან ქეისებს ტელეფონისთვის',
  'feat.why.changeTetriOff': 'ჩართე, თუ წვრილი ხურდა ხშირად არ გაქვთ (წონით გაყიდვა, თეთრიანი ფასები)',
  'feat.why.storeOn': 'მაღაზიას საიტი აქვს',
  // 2026-10-02 — the on-screen keyboard for a touch-screen till (lib/touch-keyboard.ts)
  'vkb.title': 'ეკრანის კლავიატურა',
  'vkb.hint': 'სენსორული ეკრანის სალაროსთვის: ველზე შეხებისას ჩვენი კლავიატურა ამოდის — ციფრები თანხისა და რაოდენობისთვის, ქართული ასოები ძებნისთვის. მხოლოდ ამ მოწყობილობაზე.',
  'vkb.off': 'გამორთული',
  'vkb.off.hint': 'ჩვეულებრივი კლავიატურა ან Windows-ის',
  'vkb.on': 'ჩართული',
  'vkb.on.hint': 'ციფრები და ქართული ასოები ეკრანზე',
  'vkb.touchFound': 'ამ მოწყობილობას სენსორული ეკრანი აქვს.',
  'vkb.aria': 'ეკრანის კლავიატურა',
  'vkb.enter': 'შეყვანა',
  'vkb.back': 'წაშლა',
  'vkb.clear': 'გასუფთავება',
  'vkb.hide': 'კლავიატურის დამალვა',
  'vkb.shift': 'Shift',
  'vkb.space': 'ჰარი',
  'set.day.row': 'სამუშაო დღე',
  'set.day.rowHint': 'როდის იწყება ახალი დღე',
  'set.day.1': 'სამუშაო დღე იწყება',
  'set.day.2': 'ღამის მაღაზიისთვის — რომ ერთი ღამე ორ დღედ არ გაიყოს',
  'set.day.3': 'ახალი დღე იწყება',
  'set.day.midnight': '00:00 (შუაღამე)',
  'set.day.4': 'ბუღალტერიის „დღეს" და „გუშინ", დღიური გრაფიკი, დილის ანგარიში და Telegram ამ საათიდან ითვლიან დღეს.',
  'set.day.5': 'ღამე იწერება იმ დღით, როცა დაიწყო: მაგალითად 02.10 18:00 → 03.10 07:00 არის „02.10".',
  'set.day.6': 'ღამის მაღაზიისთვის აირჩიე საათი, როცა მაღაზია დაკეტილია (მაგალითად 12:00). ჩვეულებრივ მაღაზიას 00:00 შეეფერება.',
  'set.day.7': 'ცვლა, Z-რეპორტი და ტერმინალის Z ამით არ იცვლება — ისინი ისედაც ცვლის მიხედვითაა.',
  'set.day.8': 'ამ საათს მაღაზიის მფლობელი ადგენს.',
  'set.salary.row': 'მოლარის ხელფასი',
  'set.salary.rowHint': 'ყოველდღიური, კასიდან — ცვლის დახურვისას',
  'set.salary.1': 'მოლარის დღიური ხელფასი',
  'set.salary.2': 'კასიდან გაიცემა ცვლის დახურვისას და ხარჯად ჩაიწერება',
  'set.salary.on': 'ჩართვა',
  'set.salary.off': 'გამორთვა',
  'set.salary.3': 'თანხა ₾',
  'set.salary.4': 'ცვლის დახურვისას ეს თანხა თავისით ჩაიწერება ხელფასად; „გაგაქვს კასიდან" — რაც ხელფასისა და დასატოვებელი ხურდის შემდეგ რჩება.',
  'set.salary.5': 'ხარჯებში ჩაიწერება „ხელფასი · მოლარე" ცვლის დახურვის სამუშაო დღით (პარამეტრი „სამუშაო დღე"). სხვაობა და მოსალოდნელი კასა არ იცვლება.',
  'set.salary.6': 'მოლარეს შეუძლია ნაკლების ჩაწერა (მაგ. 0). მეტს მფლობელის PIN სჭირდება.',
  'set.salary.7': 'თუ ხელფასი ცვლის შუაში უკვე გაიცა „სალაროდან გატანა → ხარჯი → ხელფასი"-ით, დახურვისას ის გამოაკლდება და ორჯერ არ ჩაიწერება. სხვა მიზეზით გატანა (მაგ. „მფლობელმა წაიღო") ხელფასად არ ითვლება.',
  'set.salary.8': 'ამ თანხას მაღაზიის მფლობელი ადგენს.',
  // „მოარგე ეკრანი" — the first-run screen fit (components/screen-fit-dialog.tsx)
  'screenFit.title': 'მოარგე ეკრანი',
  'screenFit.lede': 'ერთხელ, ამ მოწყობილობისთვის. მერე შეცვლი: პარამეტრები → გარეგნობა.',
  'screenFit.size': 'ზომა ეკრანზე',
  'screenFit.colour': 'ფერი',
  'screenFit.light': 'ღია',
  'screenFit.light.hint': 'თეთრი ფონი',
  'screenFit.dark': 'მუქი',
  'screenFit.dark.hint': 'თვალს ნაკლებად ღლის საღამოს',
  'screenFit.touch': 'შეხებით ეკრანია?',
  'screenFit.touch.no': 'არა',
  'screenFit.touch.no.hint': 'მაუსი და კლავიატურა',
  'screenFit.touch.yes': 'კი',
  'screenFit.touch.yes.hint': 'ეკრანზე გამოჩნდება ციფრები და ქართული ასოები',
  'screenFit.later': 'შემდეგ ფერებს და ზომას ნებისმიერ დროს შეცვლი.',
  'screenFit.start': 'დაწყება',
  // 1.36 — the exchange window
  'set.sec.exchange': 'გაცვლა',
  'set.exch.row': 'გაცვლის ვადა',
  'set.exch.rowHint': 'რამდენ დღეში შეუძლია მოლარეს ნივთის გაცვლა',
  'set.exch.days': 'გაცვლის ვადა (დღე)',
  'set.exch.1': 'მოლარე სალაროში ცვლის ნივთს იმავე ან უფრო ძვირ ნივთზე; მყიდველი სხვაობას იხდის, ფული უკან არ ბრუნდება.',
  'set.exch.2': 'ვადა ითვლება პირველი ყიდვიდან. ვადის გასვლის შემდეგ გაცვლას თქვენი PIN სჭირდება.',
  'set.exch.3': '0 — ყოველ გაცვლას თქვენი PIN სჭირდება.',
  'set.exch.ownerOnly': 'ამას მხოლოდ მფლობელი ცვლის.',
  'set.exch.value': '{n} დღე',
  // /scale-check — a scale on a cable, checked before a shop buys it (2026-10-17)
  'scaleCheck.title': 'სასწორის შემოწმება',
  'scaleCheck.lead': 'სანამ სასწორს იყიდი, აქ შეამოწმე: წაიკითხავს თუ არა მას MartePOS კაბელით.',
  'scaleCheck.step1': 'შეაერთე სასწორი კომპიუტერთან USB კაბელით და ჩართე.',
  'scaleCheck.step2': 'დააჭირე „სასწორის შეერთებას" და სიაში აირჩიე სასწორი.',
  'scaleCheck.step3': 'დადე რამე სასწორზე და შეადარე მის ეკრანს.',
  'scaleCheck.unsupported': 'ამ ბრაუზერში სასწორი ვერ შეერთდება. გახსენი ეს გვერდი კომპიუტერზე, Chrome-ში ან Edge-ში.',
  'scaleCheck.connect': 'სასწორის შეერთება',
  'scaleCheck.probing': 'ვამოწმებ… რამდენიმე წამი',
  'scaleCheck.ok': 'სასწორი იკითხება',
  'scaleCheck.kg': '{kg} კგ',
  'scaleCheck.stable': 'სტაბილური',
  'scaleCheck.moving': 'მერყეობს',
  'scaleCheck.compare': 'შეადარე სასწორის ეკრანს: ციფრი ერთი უნდა იყოს. აიღე და დადე ტვირთი, წონა აქაც უნდა შეიცვალოს.',
  'scaleCheck.fail': 'სასწორი არაიდენტიფიცირებულია',
  'scaleCheck.failHint': 'ასეთ სასწორს ჯერ ნუ იყიდი. გადაუღე ამ ეკრანს ფოტო და გაუგზავნე MartePOS-ს.',
  'scaleCheck.lost': 'კავშირი გაწყდა. შეამოწმე კაბელი და სცადე თავიდან.',
  'scaleCheck.openError': 'სასწორის პორტი ვერ გაიხსნა. შეიძლება მას სხვა პროგრამა იყენებს: დახურე ის და სცადე თავიდან.',
  'scaleCheck.again': 'თავიდან',
  'scaleCheck.err.overload': 'სასწორზე მეტი დევს, ვიდრე აიწონება.',
  'scaleCheck.err.notWeighing': 'სასწორი აწონვის რეჟიმში არ არის.',
  'scaleCheck.err.loadAtStart': 'ჩართვისას თეფშზე რაღაც იდო. აიღე და ჩართე სასწორი თავიდან.',
  'scaleCheck.err.faulty': 'სასწორი გაუმართავია.',
  'scaleCheck.err.other': 'სასწორმა შეცდომა დააბრუნა: {code}',
  'scaleCheck.diag': 'ტექნიკური ინფორმაცია',
  'scaleCheck.diag.port': 'პორტი',
  'scaleCheck.diag.found': 'ენა',
  'scaleCheck.diag.heard': 'თავად გამოგზავნა',
  'scaleCheck.diag.answered': 'პასუხი კითხვებზე',
  'scaleCheck.diag.error': 'შეცდომა',
  'scaleCheck.diag.none': 'არაფერი',
  'scaleCheck.settingsLink': 'სასწორის შემოწმება კომპიუტერთან',
  // 1.52 — the scale on a cable, paired on this computer
  'set.scaleCable.title': 'კაბელით — ამ კომპიუტერზე',
  'set.scaleCable.hint': 'შეაერთე სასწორი USB კაბელით და ჩართე. მერე დააჭირე ღილაკს და სიაში აირჩიე სასწორი.',
  'set.scaleCable.connected': 'შეერთებულია',
  'set.scaleCable.model': 'Massa-K · Protocol 100 · {port}',
  'set.scaleCable.forget': 'გათიშვა',
  'set.scaleCable.note': 'ინახება მხოლოდ ამ კომპიუტერზე. ჩართვისას სალარო სასწორს თვითონ იპოვის.',
  'set.scaleCable.once': 'ერთხელ საკმარისია. სხვა კომპიუტერზე სასწორი ცალკე ერთდება.',
  'set.scaleCable.unsupported': 'ამ მოწყობილობაზე სასწორი კაბელით ვერ შეერთდება. საჭიროა კომპიუტერი, Chrome ან Edge. აქ წონა ხელით ჩაიწერება.',
  'set.scaleCable.p2': 'სასწორი Protocol 2-ზეა. სალაროსთვის მის მენიუში აირჩიე Protocol 100 და სცადე თავიდან.',
  'set.scaleCable.fail': 'სასწორი ვერ ვიცანით. შეამოწმე „სასწორის შემოწმებაზე".',
  'set.scaleLabel.title': 'ეტიკეტით — შტრიხკოდი',
} as const
